import { Logo, WhatsAppIcon } from "./Logo";
import { PHONE_TEL, PHONE_DISPLAY, WHATSAPP, NAV, scrollToId } from "./data";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[var(--navy-dark)] text-white">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <Logo light />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/75">Szakszerű, diszkrét és gyors mentesítés hazai szakemberektől.</p>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/60">Menü</p>
          <ul className="mt-4 space-y-2">
            {NAV.map((n) => (
              <li key={n.id}><button data-testid={`footer-link-${n.id}`} onClick={() => scrollToId(n.id)} className="text-sm font-semibold text-white/85 hover:text-white">{n.label}</button></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/60">Kapcsolat</p>
          <a href={PHONE_TEL} data-testid="footer-call-link" className="font-display mt-4 block text-2xl font-extrabold hover:text-[#FF9A85]">{PHONE_DISPLAY}</a>
          <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-white/85 hover:text-white"><WhatsAppIcon className="h-4 w-4" /> WhatsApp üzenet</a>
          <p className="mt-3 text-sm text-white/60">[Cégnév, székhely, adószám]</p>
        </div>
      </div>
      <div className="mt-12 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/60 sm:flex-row">
        <span>© 2026 Magyar Extrém Takarítás · magyar-extremtakaritas.hu</span>
        <span>[Adatvédelmi tájékoztató] · [Impresszum]</span>
      </div>
    </div>
  </footer>
);
